<template>
<div>
  <div class="content-i">
    <div class="content-box col-sm-12 col-md-8 col-lg-6">
      <div class="element-wrapper">
        <h6 class="element-header">Invoicing</h6>
        <div class="element-box">
          <div class="element-info">
            <div class="row align-items-center">
              <div class="col-sm-8">
                <div class="element-info-with-icon">
                  <div class="element-info-icon">
                    <div class="os-icon os-icon-file">
                    </div>
                  </div>
                  <div class="element-info-text">
                    <h5 class="element-inner-header">Set Document Annual Storage Cost</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mx-0">
            <b-table id="invoicing-batches-table" striped hover bordered :fields="fields" :busy.sync="loading" :items="storageOptions" :show-empty="true">
              <template class="busy-row" slot="table-busy" slot-scope="items">
                <vcl-table :rows="4" :columns="2"></vcl-table>
              </template>
              <template v-slot:cell(batch_type)="data">
                {{ data.item.name }}
              </template>
              <template v-slot:cell(storage_cost)="data">
                <b-form-input v-model="data.item.storage_cost"></b-form-input>
              </template>
            </b-table>
          </div>
          <div class="row mx-0">
            <ResponseInfo class="mb-1 mt-1" v-if="getResponseInfo.responseName == 'docStorageCost'" />
          </div>
          <div class="col-12 text-right mt-2 px-0">
            <span class="btn btn-primary" @click="updateStorageOptions()">Update Storage Options</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ResponseInfo from '@/components/ResponseInfo.vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { VclTable } from 'vue-content-loading'
import { mapGetters } from 'vuex'

export default {
    name: 'SetDocumentStorageCost',
    components: {
        VclTable,
        ResponseInfo
    },
    data () {
      return {
          fields: [
              {key: 'batch_type', label: 'Batch Type', sortable: true, thClass: 'hover-pointer brand-color'},
              {key: 'storage_cost', label: 'Cost Rate(£)', sortable: true, thClass: 'hover-pointer brand-color small-width'},
          ],
          loading: false,
          storageOptions: null
      }
    },
    methods: {
      loadStorageOptions() {
        this.$store.dispatch('loadStorageOptions').then(response => {
          if(response.storageOptions) {
            this.storageOptions = response.storageOptions
          }
        })
      },
      updateStorageOptions() {
        this.$store.dispatch('alertClearResponse')
        this.$store.dispatch('updateStorageOptions', this.storageOptions).then(response => {

        })
      }
    },
    created() {
      this.loadStorageOptions()
    },
    computed:{
      ...mapGetters(['getResponseInfo'])
    }
}

</script>

<style scoped>
  table >>> tbody, table >>> thead{
    text-align: center;
  }
  .table  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
  .table  >>> .small-width {
    width: 200px !important;
  }
</style>
